import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LayoutContext } from '../../../../layout-context.model';

@Component({
  selector: 'gb-content-sidebar',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './content-sidebar.component.html',
})
export class ContentSidebarComponent {
  @Input({ required: true }) ctx!: LayoutContext;

  drawerOpen = false;

  toggleDrawer(): void {
    this.drawerOpen = !this.drawerOpen;
  }
}
